document.addEventListener('DOMContentLoaded', function () {
	initModal();
});

function initModal() {
	var playButtons = document.querySelectorAll('.js-open-modal');
	var modal = document.querySelector('.js-modal');
	var wrapper = document.querySelector('.js-modal-video-wrapper');

	[].forEach.call(playButtons, function (playButton) {
		playButton.addEventListener('click', function () {
			openModal();

			var iframe = document.createElement('iframe');

			iframe.setAttribute('src', '//fast.wistia.net/embed/iframe/' + this.dataset.videoId + '/?autoPlay=true&muted=false');
			iframe.setAttribute('allowtransparency', true);
			iframe.setAttribute('frameborder', 0);
			iframe.setAttribute('scrolling', 'no');
			iframe.setAttribute('name', 'wistia_embed');
			iframe.setAttribute('allowfullscreen', true);

			wrapper.appendChild(iframe);

			if (modal.classList.contains('is-visible')) {
				modal.addEventListener('click', function (event) {
					if (event.target.classList.contains('js-modal-close') || event.target.classList.contains('js-modal-overlay')) {
						closeModal();
						removeVideo();
					}
				});

				document.addEventListener('keydown', function (event) {
					if (event.keyCode === 27) {
						closeModal();
						removeVideo();
					}
				});
			}

			function removeVideo() {
				iframe.remove();
			}
		});
	});

	function openModal() {
		modal.classList.add('is-visible');
	}

	function closeModal() {
		modal.classList.remove('is-visible');
	}
}
